import React from "react";
import { useDispatch } from "react-redux";
import { setShowDistrictModal } from "../../../../../../store/superuser/actions";
import { faPlusCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, InputGroup } from "react-bootstrap";

type Props = {
  searchFilter: string;
  onSearchFilterChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const DistrictsTableActions: React.FunctionComponent<Props> = ({
  searchFilter,
  onSearchFilterChange
}) => {
  const dispatch = useDispatch();

  const onCreateDistrict = () => {
    dispatch(setShowDistrictModal({ show: true, district: null }));
  };

  return (
    <div className="d-flex justify-content-between">
      <button className="blueBtnSm mr-3" onClick={onCreateDistrict}>
        <FontAwesomeIcon icon={faPlusCircle} style={{ color: "white" }} />{" "}
        Create District
      </button>
      <InputGroup className="filterSearchDesktop mr-2" style={{width:"300px"}}>
        <InputGroup.Prepend>
          <InputGroup.Text>
            <FontAwesomeIcon icon={faSearch} />
          </InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control
          type="text"
          placeholder="Search"
          value={searchFilter}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchFilterChange(e)}
          className="filterSearchHeight"
        />
      </InputGroup>
    </div>
  );
};

export default DistrictsTableActions;
